module.exports = __webpack_public_path__ + "files/cb5754883ea95a8681ed2beec10b8a63.png";


//////////////////
// WEBPACK FOOTER
// ./images/status_yellow.png
// module id = 2574
// module chunks = 2